import { cn } from '@/shared/utils';

// import SortOptions from '@/components/SortOptions';
import FinishedCard from '@/components/livescoring/Finished/finishedCard';
// import SearchBar from '@/components/livescoring/Finished/searchBarInput';
import { EmptyUI, ErrorUI } from '@/components/ui/ErrorEmptyUI';
import LoadMore from '@/components/ui/loadMore';
import Loading from '@/components/ui/loading';
import useFinishedGames from '@/hooks/livescoring/useFinishedGames';

const Finished = () => {
  const { data, searchTerm, goToLiveScores } = useFinishedGames();
  const {
    games,
    isPending,
    isFetching,
    hasError,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = data;
  const renderedDates = new Set();

  if (hasError) {
    return (
      <section className="w-full flex justify-center items-center h-[calc(100vh-300px)]">
        <ErrorUI
          title="We couldn't load finished games"
          description="Please check your internet connection and try again."
          onRetry={() => {}}
        />
      </section>
    );
  }

  if (!isPending && games.length === 0 && !searchTerm) {
    return (
      <section
        className={cn(
          'w-full flex justify-center items-center h-[calc(100vh-300px)]'
        )}
      >
        <EmptyUI
          title="Soon someone will finish their games"
          description="Meanwhile check the live scores."
          buttonText="Go to live scores"
          onAction={goToLiveScores}
        />
      </section>
    );
  }

  return (
    <section className="max-w-[780px] mx-auto">
      <div
        className={cn(
          'max-md: pl-1',
          'flex justify-between items-center gap-8 h-16 relative'
        )}
      >
        <h1 className="text-2xl font-bold">Finished games</h1>

        {/* <SearchBar search={searchTerm} onSearch={onSearch} /> */}
      </div>

      {/* <div className="py-4">
        <SortOptions
          labels={sort.labels}
          value={sort.selected}
          onChange={sort.onChange}
        />
      </div> */}

      {isFetching && games.length === 0 && (
        <section className="w-full flex justify-center items-center h-[calc(100vh-300px)]">
          <Loading />
        </section>
      )}

      {!!searchTerm && games.length === 0 && (
        <section
          className={cn(
            'w-full flex justify-center items-center h-[calc(100vh-300px)]',
            'bg-black/30 rounded-sm'
          )}
        >
          <EmptyUI
            hideImage
            title="We couldn’t find finished games under that term"
            description="Please check the search term and try again."
          />
        </section>
      )}

      {games.length > 0 && (
        <ul className="space-y-2 lg:space-y-1">
          {games.map((game) => {
            // Check if the date has not been rendered and add it to the set
            const isNewDate = !renderedDates.has(
              game.date.toLocaleDateString()
            );
            if (isNewDate) {
              renderedDates.add(game.date.toLocaleDateString());
            }
            return (
              <li key={game.blockId} className="sm:flex gap-3">
                {/* Render date only if it's the first occurrence of a new date */}
                {isNewDate ? (
                  <time className="flex items-baseline gap-1 sm:flex-col sm:items-center text-center whitespace-nowrap text-neutral-400 w-8 pt-2">
                    <span className="text-sm font-semibold tracking-normal leading-4">
                      {game.date.toLocaleDateString('en-US', {
                        weekday: 'short',
                      })}
                    </span>
                    <span className="text-xl font-bold leading-6">
                      {game.date.toLocaleDateString('en-US', {
                        day: 'numeric',
                      })}
                    </span>
                  </time>
                ) : (
                  <div className="w-8" />
                )}

                <FinishedCard data={game} />
              </li>
            );
          })}
        </ul>
      )}

      {games.length > 0 && hasNextPage && (
        <LoadMore onLoadMore={fetchNextPage} isLoading={isFetchingNextPage} />
      )}
    </section>
  );
};

export default Finished;
